import Loading from "@/components/Loading.vue";
import { Donuz } from "@/donuz-js/Donuz";


export default {
  name: "Enter",
  components: {
    Loading
  },
  async created() {

    let resp1 = await Donuz.estabelishment.getStoreBySlug(this.$route.params.slug);

    if (resp1.status == 200) {

      // GAMBIARRA
      let resp2 = await fetch('https://app.donuz.co/api/settings',
        {
          method: 'GET',
          headers: { 'token': "410d4633ae5741efb2adf25de2c1dbb0", 'estabelecimento': resp1.estabelecimentos[0].id },
        }
      ).then(r => r.json());
      resp1.estabelecimentos[0].habilitar_pontuacao_inteira = resp2.configuracoes.habilitar_pontuacao_inteira === 1 ? true : false;
      // /GAMBIARRA

      localStorage.setItem("atualizacao", 'true');
      localStorage.setItem("estabelecimento", JSON.stringify(resp1.estabelecimentos[0]));

      location.reload();
    }
  }
}